export default __webpack_public_path__ + "static/media/ttc1.2fa05117.jpg";